<template>
  <h3>Lista respostas Formulário</h3>
  <div class="row" style="margin-bottom: 1%">
    <div class="col-3">
      <label for="cpf">CPF</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" v-model="cpf" v-mask="'###.###.###-##'" ref="cpf" />
      </div>
    </div>
    <div class="col-sm-1" style="width: 6%">
      <div class="input-group-prepend" style="margin-top: 25px">
        <span class="input-group-text bg-white" @click="search"><i class="fa fa-search"></i></span>
      </div>
    </div>
  </div>
  <a-table :dataSource="todasRespostas" :columns="columns">
    <template #nomeForm="{ record }">
      <span>{{ stringNomeForm(record) }}</span>
    </template>
    <template #nomeUsuario="{ record }">
      <span>{{ stringNomeUsuario(record) }}</span>
    </template>
    <template #cpfUsuario="{ record }">
      <span>{{ formatarCpf(record.cpfUsuario) }}</span>
    </template>
    <template #dataResposta="{ record }">
      <span>{{ stringDataResposta(record) }}</span>
    </template>
    <template #action="{ record }">
      <a @click="vizualizar(record)"><i class="fas fa-eye"></i></a>
    </template>
  </a-table>
</template>

<script>
import { getFormRespostas } from '@/components/service/formBuilderRespostasService';
import { formatCpf, validarCpf } from '@/utils/servicos-utils';

export default {
  name: 'FormBuilderRespostas',

  data() {
    return {
      todasRespostas: [],
      todasRespostasOriginal: [],
      columns: [
        {
          title: 'Nome',
          dataIndex: 'nomeForm',
          key: 'nomeForm',
          slots: { customRender: 'nomeForm' },
        },
        {
          title: 'Usuário',
          dataIndex: 'nomeUsuario',
          key: 'nomeUsuario',
          slots: { customRender: 'nomeUsuario' },
        },
        {
          title: 'CPF',
          dataIndex: 'cpfUsuario',
          key: 'cpfUsuario',
          slots: { customRender: 'cpfUsuario' },
        },
        {
          title: 'Data',
          dataIndex: 'dataResposta',
          key: 'dataResposta',
          slots: { customRender: 'dataResposta' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },

  async created() {
    await this.getFormRespostas();
    this.todasRespostasOriginal = this.todasRespostas.slice();
  },
  methods: {
    async getFormRespostas() {
      await getFormRespostas().then((esp) => {
        this.todasRespostas = esp.data;
      });
    },

    async search() {
      let value = this.$refs.cpf.value;
      if (validarCpf(value)) {
        const filtro = this.cpf.replace(/[^\d]/g, '');
        const cpfFiltrado = this.todasRespostasOriginal.filter((formulario) => formulario.cpfUsuario === filtro);
        this.todasRespostas = cpfFiltrado;
      } else {
        this.todasRespostas = this.todasRespostasOriginal.slice();
      }
    },

    watch: {
      cpf() {
        this.search();
      },
    },

    vizualizar(formBuilder) {
      this.$router.push({ path: '/questions-view-form-builder', query: { id: formBuilder.id } });
    },

    formatarCpf(cpf) {
      return formatCpf(cpf);
    },

    stringNomeForm(record) {
      return record.nomeForm;
    },
    stringNomeUsuario(record) {
      return record.nomeUsuario;
    },
    stringDataResposta(record) {
      const dataResposta = new Date(record.dataResposta);
      return `${dataResposta.toLocaleDateString()} ${dataResposta.toLocaleTimeString('pt-BR')}`;
    },
  },
};
</script>

<style scoped></style>
